import { onMounted } from '#imports';

export function useScrollTopOnMounted() {
  onMounted(() => {
    window.scrollTo({ top: 0, left: 0 });
  });
}
